export default __webpack_public_path__ + "static/media/wordpress.5bb332da.svg";